/*
 * Product gallery shows only the selected colour's photos (same rule as the
 * Liive theme, commit 114804e): a photo whose alt is "<Product> | <Colour> |
 * <shot>" belongs to that colour; "<Product> | <shot>" and photos outside the
 * convention are shared by every colour. main-product.liquid marks each slide
 * and thumbnail with data-fk-colour and only turns this on (data-fk-colour-option
 * on the gallery) when at least one photo carries a colour.
 *
 * Showcase doesn't re-render the gallery on a variant change; it fires
 * "cc-variant-updated" on window. So the non-matching slides/thumbs are taken
 * out of the DOM (kept in memory, original order preserved) and the theme's
 * Swiper / Slick are told to recount.
 */
(function () {
  function keep(el, colour) {
    var c = el.getAttribute('data-fk-colour') || '';
    return c === '' || c === 'shared' || c === colour;
  }

  function rebuild(container, items, colour) {
    items.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    items.forEach(function (el) {
      if (keep(el, colour)) { el.classList.remove('fk-off'); container.appendChild(el); }
    });
  }

  function apply(area, colour) {
    var gallery = area.querySelector('.theme-gallery[data-fk-colour-option]');
    if (!gallery || !colour) return;
    colour = String(colour).trim().toLowerCase();
    if (gallery.getAttribute('data-fk-current') === colour) return;
    gallery.setAttribute('data-fk-current', colour);

    var wrap = gallery.querySelector('.theme-images');
    if (wrap) {
      wrap._fkAll = wrap._fkAll || Array.prototype.slice.call(wrap.children);
      rebuild(wrap, wrap._fkAll, colour);
      var first = wrap.firstElementChild;
      Array.prototype.forEach.call(wrap.children, function (s) { s.classList.toggle('current-img', s === first); });
      var swEl = gallery.querySelector('[data-swiper-id]');
      var sw = swEl && window.theme && window.theme.swipers && window.theme.swipers[swEl.getAttribute('data-swiper-id')];
      if (sw) { sw.update(); sw.slideTo(0, 0); }
    }

    var carousel = area.querySelector('.product-area__details__thumbs .carousel');
    if (carousel) {
      var $ = window.jQuery;
      if ($ && $(carousel).hasClass('slick-initialized')) {
        $(carousel).slick('slickUnfilter');
        $(carousel).slick('slickFilter', function () {
          var t = this.querySelector('[data-fk-colour]') || this;
          return keep(t, colour);
        });
        $(carousel).slick('slickGoTo', 0, true);
      } else {
        carousel._fkAll = carousel._fkAll || Array.prototype.slice.call(carousel.children);
        rebuild(carousel, carousel._fkAll, colour);
      }
      var links = carousel.querySelectorAll('a');
      Array.prototype.forEach.call(links, function (a, i) { a.classList.toggle('thumb-active', i === 0); });
    }
  }

  function initial() {
    document.querySelectorAll('.theme-gallery[data-fk-colour-option]').forEach(function (g) {
      var area = g.closest('.product-area');
      if (area) apply(area, g.getAttribute('data-fk-selected'));
    });
  }

  // jQuery arrives in the theme's own deferred vendor.js, which can run after this file.
  function bind(tries) {
    var $ = window.jQuery;
    if (!$) {
      if ((tries || 0) < 200) setTimeout(function () { bind((tries || 0) + 1); }, 50);
      return;
    }
    $(window).on('cc-variant-updated.fkMediaFilter', function (e, args) {
      if (!args || !args.variant || !args.product) return;
      document.querySelectorAll('.product-area[data-product-id="' + args.product.id + '"]').forEach(function (area) {
        var g = area.querySelector('.theme-gallery[data-fk-colour-option]');
        if (!g) return;
        apply(area, args.variant['option' + g.getAttribute('data-fk-colour-option')]);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initial(); bind(); });
  } else { initial(); bind(); }
})();
